/**
 * admin 對 @ccheng/api-client 的單一匯入口——baseURL 沿用套件內建預設
 * （http://127.0.0.1:8100，可用 NEXT_PUBLIC_CCHENG_API_BASE_URL 覆寫）。
 * onUnauthorized（401 導回登入）的實際註冊在 ../components/ApiClientBootstrap
 * （需要 next/navigation 的 useRouter，故獨立成 client component 掛在 root layout）。
 */
export {
  apiClient,
  apiRequest,
  authApi,
  configureApiClient,
  getApiBaseUrl,
  getToken,
  setToken,
  clearToken,
  ApiError,
  type ListResponse,
  type LoginRequest,
  type LoginResponse,
  type MeResponse,
} from "@ccheng/api-client";
